<template>
    <div style="background-color: #fff;">
        <div style="font-weight: bold;font-size: 14px;color: #0E193B;padding:16px 0 0px 16px;">{{ $t("locateVehicle.报警故障") }} {{ index + 1 }}</div>
        <div style="padding:16px 0 0px 16px; overflow: hidden;">
            <title_value v-for="i in items" :key="i.title" :title="i.title" :value="i.value" />
        </div>
    </div>
</template>
<script>
import title_value from "./title_value"
export default {
    props: {
        info: {
            type: Object,
            default: () => { }
        },
        index: {
            type: Number,
            default: 0
        }
    },
    watch: {
        info: {
            handler(newVal, oldVal) {
                console.log(newVal)
                if (newVal) {
                    this.items = [
                        { title: this.$t("locateVehicle.报警类型"), value: newVal.Failure },
                        { title: this.$t("locateVehicle.开始时间"), value: newVal.FailureTimec },
                        { title: this.$t("locateVehicle.位置"), value: newVal.Location },
                    ]
                }
            },
            deep: true
        }
    },
    components: {
        title_value
    },
    mounted() {
        console.log(this.info)
        if (this.info) {
            this.items = [
                { title: this.$t("locateVehicle.报警类型"), value: this.info.Failure },
                { title: this.$t("locateVehicle.开始时间"), value: this.info.FailureTimec },
                { title: this.$t("locateVehicle.位置"), value: this.info.Location },
            ]
        }
    },

    data() {
        return {
            items: [
                { title: this.$t("locateVehicle.报警类型"), value: "" },
                { title: this.$t("locateVehicle.开始时间"), value: "" },
                { title: this.$t("locateVehicle.位置"), value: "" }
            ]
        }
    }
}
</script>